import { render, staticRenderFns } from "./ComprehendEntities.vue?vue&type=template&id=3979ff5a&"
import script from "./ComprehendEntities.vue?vue&type=script&lang=js&"
export * from "./ComprehendEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports